export default __webpack_public_path__ + "static/media/home-marketing-agency-bg-img-02.3ad4e9b7.jpg";